var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "annotation-card" },
    [
      _c(
        "template-card-v2",
        {
          staticClass: "annotation-card",
          attrs: {
            hasHistory: false,
            label: _vm.label,
            linkedid: _vm.linkedid,
            linkedtype: _vm.linkedtype,
            oneLog: _vm.oneLog
          }
        },
        [
          _c(
            "template",
            { slot: "icon" },
            [
              _c("CompassObject", {
                attrs: { object: "comment", size: "small" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "label" },
            [
              _c("person-list-light", {
                attrs: {
                  list: [_vm.oneLog.owner],
                  placeholderSingular: "Collaborateur",
                  placeholderPlural: "Collaborateurs"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", [
              _c("div", { staticClass: "wp-10 info flex-level flex-top" }, [
                _c(
                  "div",
                  { staticClass: "wp-10" },
                  [
                    !_vm.editMode
                      ? _c("div", [
                          _vm.oneLog.timetracking &&
                          _vm.oneLog.timetracking.service
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "typographies-paragraph-small-regular annotation-card-timer__container"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.oneLog.timetracking.service
                                        ) +
                                        "\n                                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.oneLog.timetracking.timeFormatted.length
                                    ? _c("span", [_vm._v("- ")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.oneLog.timetracking.timeFormatted.length
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "annotation-card-timer__content-time"
                                        },
                                        [
                                          _c("CompassIcon", {
                                            staticClass: "mx-1 gray-80",
                                            attrs: {
                                              type: "secondary",
                                              size: "extra-small",
                                              icon: "nav-timetracking"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.oneLog.timetracking
                                                  .timeFormatted
                                              ) +
                                              "\n                                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c("div", {
                                ref: "annotContent" + _vm.oneLog.objectid,
                                staticClass:
                                  "editor-preview typographies-paragraph-medium-regular rich-text-style annotation-card__content",
                                class: _vm.contentClass,
                                attrs: {
                                  id: "annotContent" + _vm.oneLog.objectid
                                }
                              }),
                              _vm._v(" "),
                              _vm.oneLog.content.length > 256
                                ? _c("CompassButton", {
                                    staticClass: "annotation-card__button-read",
                                    attrs: {
                                      label: _vm.fullText
                                        ? _vm.labelsButton.readLess
                                        : _vm.labelsButton.readMore,
                                      type: "secondary",
                                      size: "small"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.fullText = !_vm.fullText
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _c(
                          "el-form",
                          {
                            ref: "updateAnnotationForm",
                            staticClass: "mb-0 annotation-card-edit__container",
                            attrs: { rules: _vm.rules, model: _vm.ruleForm }
                          },
                          [
                            _c("RichText", {
                              staticClass: "annotation-richtext",
                              attrs: {
                                options: _vm.optionsRichText,
                                typeRichText: "comment",
                                refRichText: _vm.refRichTextEdit,
                                showAIComponents: _vm.showAIComponents,
                                hash: _vm.hashRichTextEdit
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.timetrackingEnabled
                                    ? {
                                        key: "more-custom-options",
                                        fn: function() {
                                          return [
                                            _c("TimetrackingRichText", {
                                              attrs: {
                                                showMenuTimetracking:
                                                  _vm.displayTimetrackingForm,
                                                mode: "edit",
                                                defaultOptions:
                                                  _vm.defaultOptions,
                                                refRichText: _vm.refRichTextEdit
                                              },
                                              model: {
                                                value: _vm.ruleForm,
                                                callback: function($$v) {
                                                  _vm.ruleForm = $$v
                                                },
                                                expression: "ruleForm"
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null,
                                  _vm.canSaveAnnotation
                                    ? {
                                        key: "actions",
                                        fn: function() {
                                          return [
                                            _c("CompassButton", {
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "common.actions.cancel"
                                                ),
                                                type: "secondary",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.cancel()
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("CompassButton", {
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "common.actions.save"
                                                ),
                                                type: "primary",
                                                size: "small",
                                                loading: _vm.confirmLoading
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.submitForm(
                                                    "updateAnnotationForm",
                                                    "submitUpdate",
                                                    {
                                                      id: _vm.oneLog.objectid
                                                    }
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.tmpContent,
                                callback: function($$v) {
                                  _vm.tmpContent = $$v
                                },
                                expression: "tmpContent"
                              }
                            })
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _vm.mentionAddedInEditing
                      ? _c("div", { staticClass: "fs-2 gray-80 mt-1" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Les notifications ne sont pas envoyées lors d'une édition de commentaire"
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3", attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.replies && _vm.replies.length > 0
                ? _c("div", { staticClass: "annotation-card__replies" }, [
                    _vm.replies.length > 2
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "annotation-card__replies--more prelative zi-1"
                          },
                          [
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.seeMoreAnswers,
                                type: "secondary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleAllAnnot()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.displayAllAnnot
                      ? _c(
                          "ul",
                          { staticClass: "m-0" },
                          _vm._l(_vm.last2annot, function(reply) {
                            return _c(
                              "li",
                              {
                                key: reply.id,
                                staticClass:
                                  "relative flex-level flex-top annotation-card__item"
                              },
                              [
                                _c("AnnotationCardReply", {
                                  attrs: { reply: reply },
                                  on: { "update-reply": _vm.updateReply }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _c(
                          "ul",
                          { staticClass: "m-0" },
                          _vm._l(_vm.replies, function(reply) {
                            return _c(
                              "li",
                              {
                                key: reply.id,
                                staticClass:
                                  "relative flex-level flex-top annotation-card__item"
                              },
                              [
                                _c("AnnotationCardReply", {
                                  attrs: { reply: reply },
                                  on: { "update-reply": _vm.updateReply }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex-row annotation-card-reply-action__container br annotation-reply-container"
                },
                [
                  _c("CompassAvatar", {
                    attrs: {
                      initials: _vm.getUserInitials,
                      avatarColorType: _vm.avatarColor(_vm.getUserName),
                      size: "extra-small"
                    }
                  }),
                  _vm._v(" "),
                  _c("RichText", {
                    staticClass: "annotation-richtext",
                    attrs: {
                      placeholder: _vm.$t.__("common.actions.answer_message"),
                      options: _vm.optionsRichText,
                      typeRichText: "comment",
                      useStorage: true,
                      refRichText: _vm.refRichText,
                      hash: _vm.hashRichTextReply,
                      showAIComponents: _vm.showAIComponents
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.canSaveReply
                          ? {
                              key: "actions",
                              fn: function() {
                                return [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.cancel"),
                                      type: "secondary",
                                      size: "small"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.resetAnnotReply($event)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.save"),
                                      type: "primary",
                                      size: "small",
                                      loading: _vm.confirmLoading
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.submitReply($event)
                                      }
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.newReply,
                      callback: function($$v) {
                        _vm.newReply = $$v
                      },
                      expression: "newReply"
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }